import { render } from "./TimelessTable.vue?vue&type=template&id=8fa9cfe8"
import script from "./TimelessTable.vue?vue&type=script&lang=js"
export * from "./TimelessTable.vue?vue&type=script&lang=js"
script.render = render

export default script